import $ from 'jquery';
import RTE from '../components/RTE';
import fitvids from 'fitvids';
import * as breakpoint from '@pixelunion/breakpoint';

export default class DynamicVideo {
  constructor(section) {
    this.el = section.el;
    this.$el = $(this.el);

    this.videoWrapper = $('.home-video-embed-wrapper', this.el);
    this.video = $('.home-video-embed', this.el);
    this.videoID = $('.home-video', this.el).data('video-id');
    this.videoType = $('.home-video', this.el).data('video-type');
    this.detachedVideo = null;
    this.rteEls = this.el.querySelectorAll('.rte');
    this.rtes = [];

    if (this.videoType === 'vimeo') {
      $.getJSON(
        `https://www.vimeo.com/api/v2/video/${this.videoID}.json?callback=?`,
        { format: 'json' },
        data => $('.vimeo-image', this.el).attr('src', data[0].thumbnail_large),
      );
    }

    for (let i = 0; i < this.rteEls.length; i++) {
      this.rtes.push(new RTE(this.rteEls[i]));
    }

    $('.home-video-play-button', this.el).on('click.video', this.openVideo.bind(this));

    breakpoint.onChange(() => {
      $('.home-video-play-button', this.el).on('click.video', this.openVideo.bind(this));
    });

    $(document).on('keyup.video', this.closeVideo.bind(this));
  }

  openVideo() {
    this.videoWrapper.addClass('opening');

    if (this.detachedVideo) {
      this.video.width('');
      this.detachedVideo.appendTo(this.video);
    } else {
      fitvids(this.video);
    }

    this.verticallyCenterVideo();

    $(window).on('resize.video', () => this.verticallyCenterVideo());

    this.videoWrapper.on('click.video', () => this.closeVideo());

    this.timeout = setTimeout(() => this.videoWrapper.addClass('open'), 20);
  }

  centerVideoText() {
    const videoContent = $('.home-video-content', this.el);

    const contentWidth = videoContent.outerWidth();
    const contentHeight = videoContent.outerHeight();

    return videoContent.css({
      marginTop: -(contentHeight / 2),
      marginLeft: -(contentWidth / 2),
    });
  }

  verticallyCenterVideo() {
    // Reset everything so the calculations are always fresh
    this.video.css({
      marginTop: 0,
      width: '100%',
    });

    const video = this.video.find('.fluid-width-video-wrapper');
    const videoHeight = video.outerHeight();
    const videoRatio = video.width() / videoHeight;
    const windowHeight = window.innerHeight || $(window).height();
    const availableHeight = windowHeight - 60; // for padding

    if (videoHeight > availableHeight) {
      this.video.removeClass('centered').css({
        marginTop: 0,
        width: availableHeight * videoRatio,
      });
    } else {
      this.video.addClass('centered').css({
        marginTop: -(videoHeight / 2),
        width: '100%',
      });
    }
  }

  closeVideo(e) {
    if (!$('.home-video').length) {
      return;
    }

    if (e && this.videoWrapper.hasClass('open')) {
      if (e.which !== 27) {
        return;
      }
    }

    $(window).off('resize.video');
    this.videoWrapper.off('click.video');

    this.videoWrapper.removeClass('open');

    const detach = () => {
      this.detachedVideo = this.video.find('.fluid-width-video-wrapper').detach();
      return this.videoWrapper.removeClass('opening').off(this.transitionend);
    };

    this.videoWrapper.one(this.transitionend, () => detach());

    this.timeout2 = setTimeout(
      () => {
        if (this.videoWrapper.hasClass('opening')) { detach(); }
      },
      300,
    );
  }

  onSectionUnload() {
    clearTimeout(this.timeout);
    clearTimeout(this.timeout2);
    this.rtes.forEach(rte => rte.unload());
    $(window).off('resize.video');
    this.videoWrapper.off('click.video');
    $('.home-video-play-button', this.el).off('click.video');
    $(document).off('keyup.video');
  }
}
